import { MainContentPlaceholderWrapper } from "../EditorStyles";
import { FormattedMessage } from "react-intl";

const NoDataNotice = () => {
  return (
    <div style={{padding: "16px"}}>
      <FormattedMessage
          id="editor.no-data-notice"
          defaultMessage="There are no data available."
          description="No data notice message"
        />
    </div>
  );
};

export default NoDataNotice;
